import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import "./Home.css";
import CustomButton from "../utils/Button/CustomButton";
import FeaturedSection from "../navigationSection/NavbarOverview";
import { Calendar2, Download, CameraVideo, GeoAlt } from "react-bootstrap-icons";
import { Grid } from "@mui/material";
import { BOOKING, IMAGES, OFFICE } from "../../config/site";

function Home() {
  const fullText1 = "Psychologue clinicienne.";
  const fullText2 = "Thérapies Cognitives et Comportementales.";
  
  const [typedText, setTypedText] = useState("");
  const [isTyping, setIsTyping] = useState(true);
  const [textIndex, setTextIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  
  const longText = `Psychologue clinicienne diplômée, je suis titulaire d'un Master en Psychopathologie Clinique d'orientation psychanalytique ainsi que d'un Master en Thérapies Cognitives et Comportementales (TCC).

J'accompagne avec bienveillance les enfants, adolescents, adultes et personnes âgées confrontés à des difficultés psychologiques, émotionnelles ou comportementales.

Mon approche est personnalisée et intégrative, alliant écoute active et outils thérapeutiques adaptés, afin d'offrir un accompagnement sur mesure, respectueux du rythme et des besoins de chacun.`;

  useEffect(() => {
    const currentText = textIndex === 0 ? fullText1 : fullText2;
    
    if (isTyping) {
      // Phase d'écriture du texte
      if (charIndex < currentText.length) {
        const timeout = setTimeout(() => {
          setTypedText(prev => prev + currentText[charIndex]);
          setCharIndex(charIndex + 1);
        }, 100); // Vitesse d'écriture
        
        return () => clearTimeout(timeout);
      } else {
        // Texte entièrement écrit, attendre avant d'effacer
        const timeout = setTimeout(() => {
          setIsTyping(false);
        }, 2000); // Pause de 2 secondes lorsque le texte est complètement écrit
        
        return () => clearTimeout(timeout);
      }
    } else {
      // Phase d'effacement du texte
      if (charIndex > 0) {
        const timeout = setTimeout(() => {
          setTypedText(prev => prev.slice(0, -1));
          setCharIndex(charIndex - 1);
        }, 50); // Vitesse d'effacement
        
        return () => clearTimeout(timeout);
      } else {
        // Texte entièrement effacé, passer au texte suivant
        setTextIndex(textIndex === 0 ? 1 : 0);
        setIsTyping(true);
      }
    }
  }, [charIndex, isTyping, textIndex, fullText1, fullText2]);

  return (
    <>
      <Box sx={{ width: "100%", minHeight: "70vh" }} className="box" id="home">
        {/* Titre animé (machine à écrire) — pleine largeur, au-dessus du paragraphe et de la photo */}
        <h2 className="hero-signature" aria-label={`Nawel BOUCHOUKH - ${fullText1}`}>
          Nawel BOUCHOUKH&nbsp;–&nbsp;{typedText}
        </h2>
        <Grid container spacing={3} alignItems="center">
          {/* Colonne de contenu (paragraphe de présentation) */}
          <Grid item xs={12} md={7} lg={8}>
            <div className="content">
              <p className="description-text">{longText}</p>
            </div>
          </Grid>

          {/* Colonne de l'image */}
          <Grid item xs={12} md={5} lg={4}>
            <div className="image-container">
              <div className="photo-frame">
                <img
                  src={IMAGES.face}
                  alt="Psychologue Nawel BOUCHOUKH"
                />
                <span className="photo-caption">
                  Nawel BOUCHOUKH
                  <small>Psychologue clinicienne</small>
                </span>
              </div>
            </div>
          </Grid>
        </Grid>

        {/* Modalités de consultation + carte de visite */}
        <div className="hero-consult">
          <div className="consultation-info">
            <h3 className="consultation-title">Modalités de consultation</h3>
            <div className="consultation-options">
              <div className="consultation-option">
                <div className="consultation-icon physical">
                  <GeoAlt size={20} />
                </div>
                <div className="consultation-details">
                  <h4>En cabinet, à domicile &amp; en téléconsultation</h4>
                  <p>
                    Prise de rendez-vous, en présentiel comme en
                    téléconsultation, exclusivement via <strong>Doctolib</strong>.
                  </p>
                  <div className="consultation-modes">
                    <span className="consultation-mode">
                      <GeoAlt size={16} /> Cabinet &amp; domicile
                    </span>
                    <span className="consultation-mode">
                      <CameraVideo size={16} /> Téléconsultation
                    </span>
                  </div>
                  <span className="consultation-address">{OFFICE.addressLine}</span>
                  <div className="consultation-buttons">
                    <CustomButton
                      toDisplay="Prendre rendez-vous sur Doctolib"
                      logo={IMAGES.doctolib}
                      icon={<Calendar2 />}
                      link={BOOKING.doctolib}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="buttons">
            <CustomButton
              toDisplay="Carte de visite"
              logo=""
              icon={<Download />}
              link={IMAGES.visitCardBack}
            />
          </div>
        </div>
      </Box>
      <FeaturedSection />
    </>
  );
}

export default Home;
